import React, { useState, useEffect } from "react";
import { bool } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { actions as debinActions } from "reducers/debin";

import { debinOptions } from "util/debin";

import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Drawer from "pages/_components/Drawer/Drawer";
import Button from "pages/_components/Button";
import TitleColumns from "./components/TitleColumns";
import EmitedSideBarForm from "../_components/SideBarForm";
import FilterTags from "../_components/FilterTags";
import ItemRow from "./components/ItemRow";

const ScheduledDebinList = ({ isDesktop }) => {
    const { fetching, totalPages, pageNumber, filterRecurrencyList, scheduledDebins } = useSelector(
        (state) => state.debin,
    );
    const dispatch = useDispatch();
    const [debinPagination, setDebinPagination] = useState(pageNumber);
    const [openSidebar, setOpenSidebar] = useState(false);
    const [scheduledDebinsFiltered, setScheduledDebinsFiltered] = useState(null);
    const hasMoreData = pageNumber < totalPages;
    const row = isDesktop ? 1 : 3;

    const debinsFiltered = () => {
        if (filterRecurrencyList?.status === "RECHAZADO") {
            setScheduledDebinsFiltered(scheduledDebins.filter((debin) => debin.status === "Rechazado"));
        } else if (filterRecurrencyList?.status === "PENDIENTE") {
            setScheduledDebinsFiltered(scheduledDebins.filter((debin) => debin.status === "Pendiente"));
        } else if (filterRecurrencyList?.status === "FINALIZADO") {
            setScheduledDebinsFiltered(scheduledDebins.filter((debin) => debin.status === "Finalizado"));
        } else {
            setScheduledDebinsFiltered(scheduledDebins);
        }
    };

    useEffect(() => {
        dispatch(
            debinActions.scheduledDebinList({
                pageNumber: 1,
            }),
        );
    }, []);

    useEffect(() => {
        if (scheduledDebins?.length > 0) {
            debinsFiltered();
        } else {
            setScheduledDebinsFiltered(null);
        }
    }, [scheduledDebins]);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const fetchMoreDebins = () => {
        setDebinPagination(pageNumber + 1);
        dispatch(debinActions.scheduledDebinList({ ...filterRecurrencyList, pageNumber: debinPagination + 1 }));
    };

    const handleDebinOnClick = (id) => {
        dispatch(
            debinActions.setScheduledDebin(scheduledDebins.filter((debin) => debin.id === id).reduce((deb) => deb)),
        );
    };

    return (
        <>
            <ResponsiveHeader id="debin.scheduled.title" backLinkTo="/desktop" />

            <MainContainer className="debin" showLoader={fetching}>
                <div className="container">
                    <FilterTags openSideBarFilters={openSideBarFilters} optiondebin={debinOptions[0]} isScheduled />
                    {scheduledDebinsFiltered?.length ? (
                        <>
                            <ProductList
                                fetchingWithPreviousData
                                fetching={fetching}
                                items={scheduledDebinsFiltered || []}
                                noDataText="debin.scheduled.empty"
                                noFiltersDataText="debin.scheduled.empty"
                                renderItem={(item) => (
                                    <GridTable.Container
                                        rows={row}
                                        key={`scheduledDebin-item-${item.id}`}
                                        renderAs={Link}
                                        to={`/scheduledDebin/detail/${item.id}`}
                                        onClick={() => handleDebinOnClick(item.id)}>
                                        <ItemRow
                                            key={`scheduledDebin-${item.id}`}
                                            scheduledDebin={item}
                                            isDesktop={isDesktop}
                                        />
                                    </GridTable.Container>
                                )}>
                                {(listItem) => (
                                    <GridTable className="debin-table">
                                        <GridTable.Header>
                                            <GridTable.Container rows={row}>
                                                <TitleColumns />
                                            </GridTable.Container>
                                        </GridTable.Header>
                                        <GridTable.Body>
                                            {listItem}
                                            {hasMoreData && (
                                                <Button
                                                    bsStyle="link"
                                                    onClick={() => fetchMoreDebins()}
                                                    image="images/figma/icon/arrow.svg"
                                                    label="global.showMore"
                                                />
                                            )}
                                        </GridTable.Body>
                                    </GridTable>
                                )}
                            </ProductList>
                        </>
                    ) : (
                        <EmptyScreenAlert message="debin.scheduled.empty" />
                    )}
                    <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                        <EmitedSideBarForm closeSidebar={setOpenSidebar} isScheduled />
                    </Drawer>
                </div>
            </MainContainer>
        </>
    );
};
ScheduledDebinList.defaultProps = {};

ScheduledDebinList.propTypes = {
    isDesktop: bool.isRequired,
};

export default ScheduledDebinList;
